import { css } from '@emotion/react';
import { Trans } from '@lingui/macro';
import React, { Fragment } from 'react';

import { PresenterFragment } from '$/GraphQL/schema/schema';
import { imageSrcFromRef, useImageSrcFromRef } from '$/hooks/useImageSrcFromRef';

import { withWebinarPlayerContext } from '$/components/WebinarPlayer/context';

import ViewerCount from '../ViewerCount';

const PresentedBy: React.FC<{ presenters: PresenterFragment[] }> = ({ presenters }) => {
  return <span className='mx-1/4e'>{presenters.map((p) => p?.name).join(', ')}</span>;
};

export const TitleAndPresenters: React.FC<{ className?: string }> = withWebinarPlayerContext(
  ['ewebinar'],
  'TitleAndPresenters'
)(({ className, context }) => {
  const { ewebinar } = context;
  const presenters = React.useMemo(() => {
    return [...(ewebinar.presenters ?? [])].reverse();
  }, [ewebinar.presenters]);

  return (
    <>
      <div
        // Controls backdrop that covers only presenters
        className='controls-backdrop controls-top'
        css={css`
          top: 0;
          height: 33%;
          max-height: 25rem;
          background: linear-gradient(180deg, #000 0%, #000 40%, #00000000 100%) !important;
          pointer-events: none;
        `}
      />

      <div
        className={`absolute z-player-backdrop scale-control control w-full-control duration-200 transition-opacity top-control room-info ${className}`}
        css={css`
          transform-origin: top left;
          left: 2%;
          top: 3%;
        `}
      >
        <div className='flex items-start'>
          <div className='flex flex-col'>
            {presenters?.reverse().map((presenter, index) => {
              const profileMediaUrl = imageSrcFromRef(presenter?.profileMediaRef, {
                w: 42,
                h: 42,
                ar: 1,
                faceindex: 1,
                facepad: 5,
                mask: 'ellipse',
                fit: 'facearea',
              });
              return (
                <Fragment key={presenter?.id}>
                  {presenter?.profileMediaRef && (
                    <img
                      className='w-3e h-3e rounded-full'
                      css={css`
                        border: 0;
                        background: white;
                        margin-top: ${index === 0 ? -5 : -15}px;
                        z-index: ${presenters.length + index};
                      `}
                      src={profileMediaUrl}
                      alt={presenter?.profileMediaRef.alt ?? 'Presenter profile image'}
                    />
                  )}
                </Fragment>
              );
            })}
          </div>
          <div>
            <div className='over-backdrop md:px-1/2e px-1e leading-snug font-semibold text-2xl'>
              {ewebinar.title}
            </div>
            {presenters && presenters.length > 0 && (
              <div className='over-backdrop text-lg md:pl-1/2e pl-1e pr-1/4e mt-1/4e flex items-center'>
                <Trans>
                  Presented by <PresentedBy presenters={presenters} />
                </Trans>
                <ViewerCount />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
});
